import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import {
  FilterExtended,
  FilterReportDataExtended,
} from '../../../components/Reports/FilterExtended';
import { ReportByPakAnalysisMoneyPenaltiesType } from '../../../components/ReportByPakAnalysisMoneyPenaltiesType/ReportByPakAnalysisMoneyPenaltiesType';
import { ReportPakAnalysisMoneyPenaltiesType } from '../../../../common/types/ReportTypes';

export const ReportAnalysisMoneyPenaltiesView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<
    FilterReportDataExtended | undefined
  >({});

  const [data, setData] = useState<ReportPakAnalysisMoneyPenaltiesType[]>();

  const onSearch = (filter?: FilterReportDataExtended) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports
      .reportPakAnalysisMoneyPenalties(filter)
      .then(dataReports => {
        setData(dataReports);
      });
  };

  return (
    <>
      <FilterExtended
        onSearch={onSearch}
        reportName="Kary pieniężne"
        productDescription="Wyrób"
        filterList={['dateFrom', 'dateTo', 'organizationalUnit', 'product']}
      />
      <ReportByPakAnalysisMoneyPenaltiesType
        data={data || []}
        dataCSV={data || []}
        reportName="Kary pieniężne"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
      />
    </>
  );
};
